(function() {
    'use strict';
    angular.module('eclipseApp.core').factory('userPrefService', function() {
        var showFirstTimeLoginPopUp = true;


        function clearHistory() {
            showFirstTimeLoginPopUp = true;
        }


        function setShowFirstTimeLoginPopUp(data) {
            showFirstTimeLoginPopUp = data;
        }

        function getShowFirstTimeLoginPopUp() {
            return showFirstTimeLoginPopUp;
        }


        return {
            setShowFirstTimeLoginPopUp: setShowFirstTimeLoginPopUp,
            getShowFirstTimeLoginPopUp: getShowFirstTimeLoginPopUp,
            clearHistory: clearHistory


        }
    });
    })();
